export default "__VITE_ASSET__B2JtzA0e__"